import { useApplicationType, useIsNuxtReady } from '@st/use/composables'
/* eslint no-underscore-dangle: 0 */

declare global {
  // eslint-disable-next-line -- why var see in https://stackoverflow.com/questions/59459312/using-globalthis-in-typescript
  var _mtm: unknown[]
}

export function useAnalyticsScript() {
  const { isNuxtReady } = useIsNuxtReady()
  const { platform } = usePlatform()
  const { isTelegramMiniApp, isPwa } = useApplicationType()
  const config = useRuntimeConfig()

  const currentPlatform = computed(() => {
    if (isTelegramMiniApp.value) {
      return 'telegramMiniApp'
    }
    if (isPwa.value) {
      return 'pwa'
    }
    return platform.value
  })

  /**
   * По мистическим причинам не один из иструментов useScript
   * не дает возможности выполнить некий код один раз перед инициализацией скрипта
   * beforeInit срабатывает несколько раз
   */
  const isInitialized = useState<boolean>('inInitializedAnalytics', () => false)

  function initDataLayer() {
    if (isInitialized.value || import.meta.server) return

    window._mtm ||= []
    if (import.meta.dev) window._mtm.push(['enableDebugMode'])
    window._mtm.push({
      'mtm.startTime': new Date().getTime(),
      event: 'mtm.Start',
    })
    window._mtm.push({
      platform: currentPlatform.value,
    })

    isInitialized.value = true
  }

  initDataLayer()

  /**
   * Матомо кэширует скрипт с каким-то диким TTL. Для инвалидации добавляем query параметр
   */
  const timeToLiveInMS = import.meta.dev ? 1_000 : 3_600_000
  const key = Math.floor(Date.now() / timeToLiveInMS) * timeToLiveInMS
  const scriptUrl = `${config.public.matomoScriptUrl}?cacheKey=${key}`

  const matomo = useScript(
    {
      src: scriptUrl,
      async: true,
      crossorigin: false,
      referrerpolicy: false,
    },
    {
      trigger: computed(() => isNuxtReady.value && !!scriptUrl),
      use: () => globalThis._mtm,
    },
  )

  matomo.onError((err: any) => {
    console.error(`Analytics script not loaded: ${err}`)
  })

  return matomo
}
